import { WorkstationEfficiencyModel } from "./workstation-efficiency.model";

export class LineEfficiencyModel {
    lineId: string;
    lineDesc: string;
    efficiency: number; // last op
    workstationWiseEfficiency: WorkstationEfficiencyModel[];
    hour: number;

    constructor(lineId: string,
        lineDesc: string,
        efficiency: number, workstationWiseEfficiency: WorkstationEfficiencyModel[], hour: number) {
            this.lineId = lineId;
            this.lineDesc = lineDesc;
            this.efficiency = efficiency;
            this.workstationWiseEfficiency = workstationWiseEfficiency;
            this.hour = hour;
    }
}